module.exports = __webpack_public_path__ + "Helvetica.8b8257c489fb03932bac.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-jnnet/src/app/@theme/fontes/Helvetica/Helvetica.eot
// module id = ../../../../../src/app/@theme/fontes/Helvetica/Helvetica.eot
// module chunks = styles